import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import axios from '../../utils/axiosInterceptor';
import { DateTime } from 'luxon';

import {
    Container, Divider, Chip, FormControl, TextField, Grid, Box, Typography,
    Radio, FormLabel, RadioGroup, FormControlLabel, Checkbox, FormGroup,
    InputLabel, Select, MenuItem, Button, Paper, Fab, Autocomplete,
} from '@mui/material';

import { DatePicker } from '@mui/x-date-pickers/DatePicker';

import CustomMessage from '../../utils/components/CustomMessage';
import CustomChip from '../../utils/components/CustomChip';
// import FormatoCotizacion from './FormatoCotización';

const CotizadorMembranas = () => {

    let navigate = useNavigate();
    const auth = useSelector((state) => state.auth);

    const [calculate, setCalculate] = useState(false);
    const [apiRes, setApiRes] = useState({ show: false, message: '', severity: '' });

    const [tipoMembrana, setTipoMembrana] = useState('membrana');
    const [newDesign, setNewDesign] = useState(false);
    const [material, setMaterial] = useState('poliester');
    const [laminado, setLaminado] = useState(false);

    const [ancho, setAncho] = useState(0);
    const [largo, setLargo] = useState(0);

    const [largoTrabajo, setLargoTrabajo] = useState(0);
    const [anchoTrabajo, setAnchoTrabajo] = useState(0);
    const [areaTrabajo, setAreaTrabajo] = useState(0);

    const [cantidad, setCantidad] = useState(1);
    const [capas, setCapas] = useState(1);
    const [domos, setDomos] = useState(0);
    const [leds, setLeds] = useState(0);
    const [conectores, setConectores] = useState(0);

    const [costoNuevoDisenio, setCostoNuevoDisenio] = useState(0);
    const [costoImpresion, setCostoImpresion] = useState(0);
    const [costoCircuito, setCostoCircuito] = useState(0);
    const [costoLaminado, setCostoLaminado] = useState(0);
    const [costoCorte, setCostoCorte] = useState(0);
    const [costoAdhesivo, setCostoAdhesivo] = useState(0);
    const [costoEspaciador, setCostoEspaciador] = useState(0);
    const [costoDomos, setCostoDomos] = useState(0);
    const [costoConectores, setCostoConectores] = useState(0);
    const [costoLeds, setCostoLeds] = useState(0);

    const [costoSinDisenio, setCostoSinDisenio] = useState(0);
    const [costoDisenioConImpuestos, setCostoDisenioConImpuestos] = useState(0);
    const [isr, setIsr] = useState(0);
    const [iva, setIva] = useState(0);
    const [precioUnitario, setPrecioUnitario] = useState(0);

    const [costoProduccionSinGastosFijos, setCostoProduccionSinGastosFijos] = useState(0);
    const [gastosFijosDiarios10pza, setGastosFijosDiarios10pza] = useState(0);
    const [costoTotalProduccion, setCostoTotalProduccion] = useState(0);

    const [margenDeUtilidad, setMargenDeUtilidad] = useState(0);
    const [precioDistribuidor, setPrecioDistribuidor] = useState(0);
    const [ivaDistribuidor, setIvaDistribuidor] = useState(0);
    const [gatsosDistribuidor, setGastosDistribuidor] = useState(0);
    const [utilidadDistriuidor, setUtilidadDistribuidor] = useState(0);


    const [ivaCliente, setIvaCliente] = useState(0);
    const [precioCliente, setPrecioCliente] = useState(0);

    const [cotizacion, setCotizacion] = useState({
        tipoMembrana: '',
        newDesign: false,
        material: '',
        laminado: false,
        dimensiones: {
            ancho: 0,
            largo: 0,
        },
        descripcion: '',

    });

    const depreciacionMaquinasMensual = [
        { maquina: 'Plotter UV', depreciacion: 7500 },
        { maquina: 'CO2', depreciacion: 1666 },
        { maquina: 'Laminador', depreciacion: 666 },
        { maquina: 'Computadoras', depreciacion: 333 },
    ];

    const gastosFijosMensuales = [
        { concepto: 'Electricidad', costo: 1784 },
        { concepto: 'Agua', costo: 322 },
        { concepto: 'Nómina', costo: 63800 },
    ]

    const gastosFijosDiarios =
        ((depreciacionMaquinasMensual.map((maquina) => maquina.depreciacion).reduce((a, b) => a + b)) +
            (gastosFijosMensuales.map((gasto) => gasto.costo).reduce((a, b) => a + b))) / 20;

    const consumibles = [
        { concepto: 'Tinta UV', unidad: '$/cm2', costo: 0.12 },
        { concepto: 'Impresión Poliester', unidad: '$/cm2', costo: 0.012 },
        { concepto: 'Impresión Policarbonato', unidad: '$/cm2', costo: 0.024 },
        { concepto: 'Sustrato Circuito', unidad: '$/cm2', costo: 0.024 },
        { concepto: 'Sustrato Espaciador', unidad: '$/cm2', costo: 0.024 },
        { concepto: 'Sustrato aislante', unidad: '$/cm2', costo: 0.01 },
        { concepto: 'Adhesivo', unidad: '$/cm2', costo: 0.012 },
        { concepto: 'Tinta de plata', unidad: '$/cm2', costo: 0.014 },
        { concepto: 'Laminado', unidad: '$/cm2', costo: 0.01 },
        { concepto: 'Emulsion', unidad: 'Capa', costo: 10 },
        { concepto: 'Leds', unidad: 'Pieza', costo: 5 },
        { concepto: 'Domos', unidad: 'Pieza', costo: 4 },
        { concepto: 'Tubo CO2', unidad: 'Capa', costo: 0.5 },
        { concepto: 'Conectores', unidad: 'Pieza', costo: 80 }
    ];

    const nuevoDiseño = [
        { concepto: 'Malla Serigrafía', unidad: 'Unidad', costo: 100 },
        { concepto: 'Acrilico material', unidad: 'cm2', costo: 0.3 },
        { concepto: 'Acrilico tiempo', unidad: 'Unidad', costo: 150 },
        { concepto: 'Botador tiempo', unidad: 'Unidad', costo: 60 },
        { concepto: 'Botador material', unidad: 'Unidad', costo: 60 },
    ]

    const [cliente, setCliente] = useState('');
    const [fechaDeCotizacion, setFechaDeCotizacion] = useState(DateTime.now());
    const [operacion, setOperacion] = useState('');
    const [descrpicion, setDescripcion] = useState('');

    const [clientes, setClientes] = useState([
        {id: 1, nombre: 'Cliente 1'},
        {id: 2, nombre: 'Cliente 2'},
        {id: 3, nombre: 'Cliente 3'},
        {id: 4, nombre: 'Cliente 4'},
        {id: 5, nombre: 'Cliente 5'},
    ]);
    const [operaciones, setOperaciones] = useState(['Venta', 'Fabricación', 'Servicio']);

    useEffect(() => {
        if (auth.user.rol !== "Admin") {
            navigate('/dashboard');
        }
        document.title = 'Nueva Cotización';
    }, [auth])

    useEffect(() => {
        getData();
    }, [])

    const getData = async () => {
        try {
            const res = await axios.get('/api/clients/');
            if (res.status === 200) {
                setClientes(res.data);
            }
        } catch (err) {
            console.log(err);
        }
    }

    const handleCloseMessage = (show) => {
        setApiRes(state => { return { ...state, show: show } })
    }

    const formatMoney = (amount, decimalCount = 2, decimal = '.', thousands = ',') => {
        if (isNaN(amount)) {
            alert('Los precios deben contener solo valores numéricos, sin letras ni símbolos');
            return;
        }

        const negativeSign = amount < 0 ? '-' : '';
        const absAmount = Math.abs(amount);
        const roundedAmount = absAmount.toFixed(decimalCount);
        const [integerPart, decimalPart] = roundedAmount.split('.');

        const formattedIntegerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, thousands);

        const formattedDecimalPart = decimalCount > 0 ? `${decimal}${decimalPart}` : '';

        return `${negativeSign}${formattedIntegerPart}${formattedDecimalPart}`;
    };

    const handleAnchoChange = (e) => {
        setAncho(Number(e.target.value));
        const currentAncho = Number(e.target.value);
        const anchoTrabajoTmp = currentAncho < 10 ? currentAncho + 4 :
            currentAncho < 20 ? currentAncho * 1.4 :
                currentAncho < 40 ? currentAncho * 1.2 :
                    currentAncho * 1.1;
        setAnchoTrabajo(anchoTrabajoTmp.toFixed(2));
    }

    const handleLargoChange = (e) => {
        setLargo(Number(e.target.value));
        const currentLargo = Number(e.target.value);
        const largoTrabajoTmp = currentLargo < 10 ? currentLargo + 4 :
            currentLargo < 20 ? currentLargo * 1.4 :
                currentLargo < 40 ? currentLargo * 1.2 :
                    currentLargo * 1.1;
        setLargoTrabajo(largoTrabajoTmp.toFixed(2));
    }

    useEffect(() => {
        setAreaTrabajo((anchoTrabajo * largoTrabajo).toFixed(2));
    }, [anchoTrabajo, largoTrabajo])

    useEffect(() => {
        setCalculate(false);
    }, [tipoMembrana])

    const handleCalculate = (e) => {
        e.preventDefault();

        console.log(newDesign);
        console.log(tipoMembrana);
        console.log(material);

        setCalculate(false);

        if (tipoMembrana === 'teclado') {
            let capasTmp = capas < 2 ? 2 : capas;
            let costoNuevoDisenioTmp = 0;
            if (newDesign) {
                if (cantidad >= 6) {
                    setCostoNuevoDisenio(0);
                } else {
                    costoNuevoDisenioTmp = 1724;
                    setCostoNuevoDisenio(costoNuevoDisenioTmp);
                }
            }

            let materialTmp = material === 'policarbonato' ?
                consumibles.find((consumible) => consumible.concepto === 'Impresión Policarbonato') :
                consumibles.find((consumible) => consumible.concepto === 'Impresión Poliester');
            let tintaUv = consumibles.find((consumible) => consumible.concepto === 'Tinta UV');

            let costoImpresionTmp = areaTrabajo * (materialTmp.costo + tintaUv.costo);
            setCostoImpresion(costoImpresionTmp);

            let emulsion = consumibles.find((consumible) => consumible.concepto === 'Emulsion');
            let sustratoAislante = consumibles.find((consumible) => consumible.concepto === 'Sustrato aislante');
            let sustratoCircuito = consumibles.find((consumible) => consumible.concepto === 'Sustrato Circuito');
            let tintaPlata = consumibles.find((consumible) => consumible.concepto === 'Tinta de plata');

            let costoCircuitoTmp = capasTmp * emulsion.costo +
                (capasTmp - 1) * sustratoAislante.costo * areaTrabajo +
                capasTmp * areaTrabajo * (sustratoCircuito.costo + tintaPlata.costo);
            setCostoCircuito(costoCircuitoTmp);

            let costoLaminadoTmp = 0;
            if (laminado) {
                let laminadoTmp = consumibles.find((consumible) => consumible.concepto === 'Laminado');
                costoLaminadoTmp = areaTrabajo * laminadoTmp.costo * 2;
                setCostoLaminado(costoLaminadoTmp);
            }

            let tuboCo2 = consumibles.find((consumible) => consumible.concepto === 'Tubo CO2');
            let costoCorteTmp = (7 + capasTmp) * tuboCo2.costo;
            setCostoCorte(costoCorteTmp);

            let adhesivo = consumibles.find((consumible) => consumible.concepto === 'Adhesivo');
            let costoAdhesivoTmp = (capasTmp + 1) * areaTrabajo * adhesivo.costo;
            setCostoAdhesivo(costoAdhesivoTmp);

            let sustratoEspaciador = consumibles.find((consumible) => consumible.concepto === 'Sustrato Espaciador');
            let costoEspaciadorTmp = (capasTmp / 2) * areaTrabajo * sustratoEspaciador.costo;
            setCostoEspaciador(costoEspaciadorTmp);

            let domosTmp = consumibles.find((consumible) => consumible.concepto === 'Domos');
            let costoDomosTmp = domosTmp.costo * domos;
            setCostoDomos(costoDomosTmp);

            let ledsTmp = consumibles.find((consumible) => consumible.concepto === 'Leds');
            let costoLedsTmp = ledsTmp.costo * leds;
            setCostoLeds(costoLedsTmp);

            let conectoresTmp = consumibles.find((consumible) => consumible.concepto === 'Conectores');
            let costoConectoresTmp = conectoresTmp.costo * conectores;
            setCostoConectores(costoConectoresTmp);

            let costoSinDisenioTmp = costoImpresionTmp + costoCircuitoTmp + costoLaminadoTmp + costoCorteTmp +
                costoAdhesivoTmp + costoEspaciadorTmp + costoDomosTmp + costoLedsTmp + costoConectoresTmp
            setCostoSinDisenio(costoSinDisenioTmp);

            let disenioNuevoConImpuestosTmp = costoNuevoDisenioTmp * 1.3 * 1.16;
            setCostoDisenioConImpuestos(disenioNuevoConImpuestosTmp);

            let isrTmp = (costoSinDisenioTmp) * 0.3;
            setIsr(isrTmp);

            let ivaTmp = (costoSinDisenioTmp + isrTmp) * 0.16;
            setIva(ivaTmp);

            let precioUnitarioTmp = costoSinDisenioTmp + isrTmp + ivaTmp;
            setPrecioUnitario(precioUnitarioTmp);

            let costoProduccionSinGastosFijosTmp = newDesign ? (disenioNuevoConImpuestosTmp + precioUnitarioTmp + precioUnitarioTmp * (cantidad - 1)) : (precioUnitarioTmp * cantidad);
            setCostoProduccionSinGastosFijos(costoProduccionSinGastosFijosTmp);

            let gastosFijosDiarios10pzasTmp = tipoMembrana === 'teclado' ? 380 : 126;
            setGastosFijosDiarios10pza(gastosFijosDiarios10pzasTmp);

            let costoTotalProduccionTmp = costoProduccionSinGastosFijosTmp + gastosFijosDiarios10pzasTmp;
            setCostoTotalProduccion(costoTotalProduccionTmp)

            let margenDeUtilidadTmp = (costoProduccionSinGastosFijosTmp + gastosFijosDiarios10pzasTmp) * 0.4;
            setMargenDeUtilidad(margenDeUtilidadTmp);

            let precioDistribuidorTmp = costoProduccionSinGastosFijosTmp + gastosFijosDiarios10pzasTmp * 1.46 + margenDeUtilidadTmp * 1.46;
            setPrecioDistribuidor(precioDistribuidorTmp);

            let gatsosDistribuidorTmp = tipoMembrana === 'teclado' ? 380 : 250;
            setGastosDistribuidor(gatsosDistribuidorTmp);

            let utilidadDistriuidorTmp = (precioDistribuidorTmp + gatsosDistribuidorTmp) * 0.4;
            setUtilidadDistribuidor(utilidadDistriuidorTmp);

            let ivaCliente = (precioDistribuidorTmp + gatsosDistribuidorTmp + utilidadDistriuidorTmp) * 0.16;
            setIvaCliente(ivaCliente);

            let precioClienteTmp = precioDistribuidorTmp + gatsosDistribuidorTmp + utilidadDistriuidorTmp + ivaCliente;
            setPrecioCliente(precioClienteTmp);


        } else if (tipoMembrana === 'membrana') {
            let capasTmp = 1
            let costoNuevoDisenioTmp = 0;
            if (newDesign) {

                costoNuevoDisenioTmp = 650;
                setCostoNuevoDisenio(costoNuevoDisenioTmp);
            }

            let materialTmp = material === 'policarbonato' ?
                consumibles.find((consumible) => consumible.concepto === 'Impresión Policarbonato') :
                consumibles.find((consumible) => consumible.concepto === 'Impresión Poliester');
            let tintaUv = consumibles.find((consumible) => consumible.concepto === 'Tinta UV');

            let costoImpresionTmp = areaTrabajo * (materialTmp.costo + tintaUv.costo);
            setCostoImpresion(costoImpresionTmp);

            let costoLaminadoTmp = 0;
            if (laminado) {
                let laminadoTmp = consumibles.find((consumible) => consumible.concepto === 'Laminado');
                costoLaminadoTmp = areaTrabajo * laminadoTmp.costo * 2;
                setCostoLaminado(costoLaminadoTmp);
            }

            let tuboCo2 = consumibles.find((consumible) => consumible.concepto === 'Tubo CO2');
            let costoCorteTmp = (2 + capasTmp) * tuboCo2.costo;
            setCostoCorte(costoCorteTmp);

            let adhesivo = consumibles.find((consumible) => consumible.concepto === 'Adhesivo');
            let costoAdhesivoTmp = (capasTmp) * areaTrabajo * adhesivo.costo;
            setCostoAdhesivo(costoAdhesivoTmp);

            let costoSinDisenioTmp = costoImpresionTmp + costoLaminadoTmp + costoCorteTmp + costoAdhesivoTmp;
            setCostoSinDisenio(costoSinDisenioTmp);

            let disenioNuevoConImpuestosTmp = costoNuevoDisenioTmp * 1.3 * 1.16;
            setCostoDisenioConImpuestos(disenioNuevoConImpuestosTmp);

            let isrTmp = (costoSinDisenioTmp) * 0.3;
            setIsr(isrTmp);

            let ivaTmp = (costoSinDisenioTmp + isrTmp) * 0.16;
            setIva(ivaTmp);

            let precioUnitarioTmp = costoSinDisenioTmp + isrTmp + ivaTmp;
            setPrecioUnitario(precioUnitarioTmp);

            let costoProduccionSinGastosFijosTmp = newDesign ? (disenioNuevoConImpuestosTmp + precioUnitarioTmp + precioUnitarioTmp * (cantidad - 1)) : (precioUnitarioTmp * cantidad);
            setCostoProduccionSinGastosFijos(costoProduccionSinGastosFijosTmp);

            let gastosFijosDiarios10pzasTmp = tipoMembrana === 'teclado' ? 380 : 126;
            setGastosFijosDiarios10pza(gastosFijosDiarios10pzasTmp);

            let costoTotalProduccionTmp = costoProduccionSinGastosFijosTmp + gastosFijosDiarios10pzasTmp;
            setCostoTotalProduccion(costoTotalProduccionTmp)

            let margenDeUtilidadTmp = (costoProduccionSinGastosFijosTmp + gastosFijosDiarios10pzasTmp) * 0.4;
            setMargenDeUtilidad(margenDeUtilidadTmp);

            let precioDistribuidorTmp = costoProduccionSinGastosFijosTmp + gastosFijosDiarios10pzasTmp + margenDeUtilidadTmp;
            setPrecioDistribuidor(precioDistribuidorTmp);

            let gatsosDistribuidorTmp = tipoMembrana === 'teclado' ? 380 : 250;
            setGastosDistribuidor(gatsosDistribuidorTmp);

            let utilidadDistriuidorTmp = (precioDistribuidorTmp + gatsosDistribuidorTmp) * 0.4;
            setUtilidadDistribuidor(utilidadDistriuidorTmp);

            let ivaCliente = (precioDistribuidorTmp + gatsosDistribuidorTmp + utilidadDistriuidorTmp) * 0.16;
            setIvaCliente(ivaCliente);

            let precioClienteTmp = precioDistribuidorTmp + gatsosDistribuidorTmp + utilidadDistriuidorTmp + ivaCliente;
            setPrecioCliente(precioClienteTmp);

        }
        setCalculate(true);
    }

    return (
        <Container maxWidth='xl'>

            <Box className='text-center py-2' >
                <Typography variant='h5' style={{ fontWeight: 700 }}>Cotizador de Membranas</Typography>
            </Box>

            <Paper sx={{ padding: '24px 0px' }} elevation={3}>

                                        <Container maxWidth='xl'>
                                            <Box className='text-center' >
                                                <Typography variant='h5' style={{ fontWeight: 700 }}>Nueva Cotización</Typography>
                                            </Box>

                                            <Divider className='my-3' textAlign="left">
                                                <CustomChip variant='outlined' estatus='AUTORIZADO' label='Datos de la cotización' className='text-bold' />
                                            </Divider>

                                            <form >
                                                <Fab aria-label="add" type='submit' color='success' style={{ position: 'fixed', top: '60px', left: '12px', zIndex: '10', opacity: '60%' }}>
                                                    <i className="fad fa-save fa-2x"></i>
                                                </Fab>

                                                <Grid container spacing={3}>
                                                    <Grid item xs={12} md={6}>
                                                        <FormControl required sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                                            <Autocomplete
                                                                disablePortal
                                                                freeSolo={true}
                                                                onInputChange={(event, newInputValue) => setCliente(newInputValue)}
                                                                inputValue={cliente}
                                                                aria-multiline='true'
                                                                options={clientes.map((option) => option.name)}
                                                                renderInput={(params) => <TextField {...params} label='Cliente' />}
                                                            />
                                                        </FormControl>
                                                    </Grid>
                                                    <Grid item xs={12} md={3}>
                                                        <FormControl required sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                                            <Autocomplete
                                                                disablePortal
                                                                freeSolo={true}
                                                                onInputChange={(event, newInputValue) => setOperacion(newInputValue)}
                                                                inputValue={operacion}
                                                                aria-multiline='true'
                                                                options={operaciones}
                                                                renderInput={(params) => <TextField {...params} label='Tipo de Operación' />}
                                                            />
                                                        </FormControl>
                                                    </Grid>
                                                    <Grid item xs={12} md={6} lg={3}>
                                                        <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                                            <DatePicker
                                                                label="Fecha de Cotización"
                                                                format="dd/MM/yyyy"
                                                                value={fechaDeCotizacion}
                                                                onChange={(newValue) => setFechaDeCotizacion(newValue)}
                                                                slotProps={{ textField: { variant: 'outlined' } }}
                                                            />
                                                        </FormControl>
                                                    </Grid>

                                                    <Grid item xs={12} md={12}>
                                                        <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                                            <TextField label="Descripción" variant="outlined" value={descrpicion} onChange={(e) => setDescripcion(e.target.value)} />
                                                        </FormControl>
                                                    </Grid>
                                                </Grid>
                                                <hr></hr>
                                                {/* <Grid container spacing={3}>
                                                    <Grid item xs={12} md={4}>
                                                        <Button variant="contained" color="success" type='submit'>Guardar &nbsp; <i className="fad fa-save"></i></Button>
                                                    </Grid>
                                                </Grid> */}
                                            </form>
                                        </Container>
                                        <CustomMessage open={apiRes.show} message={apiRes.message} severity={apiRes.severity} handleCloseMessage={handleCloseMessage} />
                                    </Paper>

            <Divider className='my-3' textAlign="left">
                <Chip variant='outlined' color='secondary' label='Tipo de Membrana' className='text-bold' />
            </Divider>

            <FormControl sx={{ minWidth: 100 }} style={{ display: 'flex' }}>
                <RadioGroup
                    aria-labelledby="demo-radio-buttons-group-label"
                    defaultValue="membrana"
                    value={tipoMembrana}
                    onChange={(e) => setTipoMembrana(e.target.value)}
                    name="radio-buttons-group"
                >
                    <FormControlLabel value="membrana" control={<Radio />} label="Membrana" />
                    <FormControlLabel value="teclado" control={<Radio />} label="Teclado de Membrana" />
                    <FormControlLabel value="sticker" control={<Radio />} label="Sticker" />
                </RadioGroup>
            </FormControl>

            <Divider className='my-3' textAlign="left">
                <Chip variant='outlined' color='secondary' label='Dimensiones' className='text-bold' />
            </Divider>

            <Grid container spacing={3}>
                <Grid item xs={12} md={6} lg={3}>
                    <FormControl sx={{ minWidth: 100 }} style={{ display: 'flex' }}>
                        <TextField id="outlined-basic" label="Ancho [cm]" type='number' variant="outlined" value={ancho} onChange={(e) => handleAnchoChange(e)} />
                    </FormControl>
                </Grid>
                <Grid item xs={12} md={6} lg={3}>
                    <FormControl sx={{ minWidth: 100 }} style={{ display: 'flex' }}>
                        <TextField id="outlined-basic" label="Largo [cm]" type='number' variant="outlined" value={largo} onChange={(e) => handleLargoChange(e)} />
                    </FormControl>
                </Grid>
                <Grid item xs={12} md={6} lg={3}>
                    <p style={{ color: '#888', fontSize: '0.7em' }} className='my-0'>Ancho de Trabajo: {anchoTrabajo} [cm]</p>
                    <p style={{ color: '#888', fontSize: '0.7em' }} className='my-0'>Largo de Trabajo: {largoTrabajo} [cm]</p>
                    <p style={{ color: '#888', fontSize: '0.7em' }} className='my-0'>Área de Trabajo: {areaTrabajo} [cm²]</p>
                </Grid>
            </Grid>

            <Divider className='my-3' textAlign="left">
                <Chip variant='outlined' color='secondary' label='Caracteristicas de la membrana' className='text-bold' />
            </Divider>

            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <FormGroup>
                        <FormControlLabel control={<Checkbox checked={newDesign}
                            onChange={() => setNewDesign(!newDesign)} />} label={!newDesign ? 'Sin Diseño Nuevo' : 'Diseño nuevo'} />
                    </FormGroup>
                </Grid>
                <Grid item xs={12} md={6} lg={2}>
                    <FormControl sx={{ minWidth: 100 }} style={{ display: 'flex' }}>
                        <TextField id="outlined-basic" label="Cantidad" type='number' variant="outlined" value={cantidad} onChange={(e) => setCantidad(Number(e.target.value))} />
                    </FormControl>
                </Grid>
                <Grid item xs={12} md={6} lg={2}>
                    <FormControl sx={{ minWidth: 100 }} style={{ display: 'flex' }}>
                        <InputLabel id="demo-simple-select-label">Material</InputLabel>
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={material}
                            label="Material"
                            onChange={(e) => setMaterial(e.target.value)}
                        >
                            {[{ material: 'poliester' }, { material: 'policarbonato' }].map((m, i) => {
                                return <MenuItem key={i} value={m.material}>{m.material}</MenuItem>
                            })}
                        </Select>
                    </FormControl>
                </Grid>
                {tipoMembrana === 'teclado' ?
                    <>
                        <Grid item xs={12} md={6} lg={2}>
                            <FormControl sx={{ minWidth: 100 }} style={{ display: 'flex' }}>
                                <TextField id="outlined-basic" label="Capas de circuito" type='number' variant="outlined" value={capas} onChange={(e) => setCapas(Number(e.target.value))} />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} md={6} lg={2}>
                            <FormControl sx={{ minWidth: 100 }} style={{ display: 'flex' }}>
                                <TextField id="outlined-basic" label="Domos" type='number' variant="outlined" value={domos} onChange={(e) => setDomos(Number(e.target.value))} />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} md={6} lg={2}>
                            <FormControl sx={{ minWidth: 100 }} style={{ display: 'flex' }}>
                                <TextField id="outlined-basic" label="Leds" type='number' variant="outlined" value={leds} onChange={(e) => setLeds(Number(e.target.value))} />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} md={6} lg={2}>
                            <FormControl sx={{ minWidth: 100 }} style={{ display: 'flex' }}>
                                <TextField id="outlined-basic" label="Conectores" type='number' variant="outlined" value={conectores} onChange={(e) => setConectores(Number(e.target.value))} />
                            </FormControl>
                        </Grid>
                    </>
                    : <></>}

                <Grid item xs={12}>
                    <FormGroup>
                        <FormControlLabel control={<Checkbox checked={laminado}
                            onChange={() => setLaminado(!laminado)} />} label={!laminado ? 'Sin Laminar' : 'Laminado'} />
                    </FormGroup>
                </Grid>
            </Grid>

            <div className='text-center'>
                <Button color='success' variant='contained' onClick={(e) => handleCalculate(e)} >Calcular</Button>
            </div>

            <Container maxWidth='xl' className='pt-5'>
                {calculate ?
                    <Paper>

                        

                        {/* <Divider className='my-3' textAlign="left">
                            <Chip variant='outlined' color='secondary' label='Modelo de costos' className='text-bold' />
                        </Divider>
                        <Grid container spacing={3} sx={{color: '#FFF'}}>
                            {tipoMembrana === 'teclado' ?
                                <Grid item xs={12} md={6} lg={3}>
                                    <p style={{ fontSize: '0.6em' }}>Costo de Fabricación</p>
                                    <table className="table table-striped" style={{ fontSize: '12px' }}>
                                        <thead>
                                            <tr>
                                                <th>Concepto</th>
                                                <th style={{ width: '20px' }}></th>
                                                <th>Costo</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>Nuevo Diseño</td>
                                                <th style={{ width: '20px' }}>$</th>
                                                <td>{formatMoney(costoNuevoDisenio)}</td>
                                            </tr>
                                            <tr>
                                                <td>Impresion</td>
                                                <th style={{ width: '20px' }}>$</th>
                                                <td>{formatMoney(costoImpresion)}</td>
                                            </tr>
                                            <tr>
                                                <td>Circuito</td>
                                                <th style={{ width: '20px' }}>$</th>
                                                <td>{formatMoney(costoCircuito)}</td>
                                            </tr>
                                            <tr>
                                                <td>Laminado</td>
                                                <th style={{ width: '20px' }}>$</th>
                                                <td>{formatMoney(costoLaminado)}</td>
                                            </tr>
                                            <tr>
                                                <td>Corte</td>
                                                <th style={{ width: '20px' }}>$</th>
                                                <td>{formatMoney(costoCorte)}</td>
                                            </tr>
                                            <tr>
                                                <td>Adhesivo</td>
                                                <th style={{ width: '20px' }}>$</th>
                                                <td>{formatMoney(costoAdhesivo)}</td>
                                            </tr>
                                            <tr>
                                                <td>Espaciador</td>
                                                <th style={{ width: '20px' }}>$</th>
                                                <td>{formatMoney(costoEspaciador)}</td>
                                            </tr>
                                            <tr>
                                                <td>Domos</td>
                                                <th style={{ width: '20px' }}>$</th>
                                                <td>{formatMoney(costoDomos)}</td>
                                            </tr>
                                            <tr>
                                                <td>Leds</td>
                                                <th style={{ width: '20px' }}>$</th>
                                                <td>{formatMoney(costoLeds)}</td>
                                            </tr>
                                            <tr>
                                                <td>Conectores</td>
                                                <th style={{ width: '20px' }}>$</th>
                                                <td>{formatMoney(costoConectores)}</td>
                                            </tr>
                                            <tr>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                            </tr>
                                            <tr>
                                                <td>Costo de fabricacion sin diseño</td>
                                                <th style={{ width: '20px' }}>$</th>
                                                <td>{formatMoney(costoSinDisenio)}</td>
                                            </tr>
                                            <tr>
                                                <td>ISR</td>
                                                <th style={{ width: '20px' }}>$</th>
                                                <td>{formatMoney(isr)}</td>
                                            </tr>
                                            <tr>
                                                <td>IVA</td>
                                                <th style={{ width: '20px' }}>$</th>
                                                <td>{formatMoney(iva)}</td>
                                            </tr>
                                            <tr>
                                                <td>Costo Unitario</td>
                                                <th style={{ width: '20px' }}>$</th>
                                                <td>{formatMoney(precioUnitario)}</td>
                                            </tr>
                                            <tr>
                                                <td>Costo de diseño con Impuestos (ISR + IVA)</td>
                                                <th style={{ width: '20px' }}>$</th>
                                                <td>{formatMoney(costoDisenioConImpuestos)}</td>
                                            </tr>
                                            <tr>
                                                <td>Costo de produccion antes de gastos fijos</td>
                                                <th style={{ width: '20px' }}>$</th>
                                                <td>{formatMoney(costoProduccionSinGastosFijos)}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </Grid> : tipoMembrana === 'membrana' ?
                                    <Grid item xs={12} md={6} lg={3}>
                                        <p style={{ fontSize: '0.6em' }}>Costo de Fabricación</p>
                                        <table className="table table-striped" style={{ fontSize: '12px' }}>
                                            <thead>
                                                <tr>
                                                    <th >Concepto</th>
                                                    <th >Costo</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td >Nuevo Diseño</td>
                                                    <th style={{ width: '20px' }}>$</th>
                                                    <td >{formatMoney(costoNuevoDisenio)}</td>
                                                </tr>
                                                <tr>
                                                    <td >Impresion</td>
                                                    <th style={{ width: '20px' }}>$</th>
                                                    <td >{formatMoney(costoImpresion)}</td>
                                                </tr>
                                                <tr>
                                                    <td >Laminado</td>
                                                    <th style={{ width: '20px' }}>$</th>
                                                    <td >{formatMoney(costoLaminado)}</td>
                                                </tr>
                                                <tr>
                                                    <td >Corte</td>
                                                    <th style={{ width: '20px' }}>$</th>
                                                    <td >{formatMoney(costoCorte)}</td>
                                                </tr>
                                                <tr>
                                                    <td >Adhesivo</td>
                                                    <th style={{ width: '20px' }}>$</th>
                                                    <td >{formatMoney(costoAdhesivo)}</td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>Costo de fabricacion sin diseño</td>
                                                    <th style={{ width: '20px' }}>$</th>
                                                    <td>{formatMoney(costoSinDisenio)}</td>
                                                </tr>
                                                <tr>
                                                    <td>ISR</td>
                                                    <th style={{ width: '20px' }}>$</th>
                                                    <td>{formatMoney(isr)}</td>
                                                </tr>
                                                <tr>
                                                    <td>IVA</td>
                                                    <th style={{ width: '20px' }}>$</th>
                                                    <td>{formatMoney(iva)}</td>
                                                </tr>
                                                <tr>
                                                    <td>Costo Unitario</td>
                                                    <th style={{ width: '20px' }}>$</th>
                                                    <td>{formatMoney(precioUnitario)}</td>
                                                </tr>
                                                <tr>
                                                    <td>Costo de diseño con Impuestos (ISR + IVA)</td>
                                                    <th style={{ width: '20px' }}>$</th>
                                                    <td>{formatMoney(costoDisenioConImpuestos)}</td>
                                                </tr>
                                                <tr>
                                                    <td>Costo de produccion antes de gastos fijos</td>
                                                    <th style={{ width: '20px' }}>$</th>
                                                    <td>{formatMoney(costoProduccionSinGastosFijos)}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </Grid> : <> </>}
                            <Grid item xs={12} md={6} lg={3}>
                                <p style={{ fontSize: '0.6em' }}>Utilidad de Produccion</p>
                                <table className="table table-striped" style={{ fontSize: '12px' }}>
                                    <thead>
                                        <tr >
                                            <th >Concepto</th>
                                            <th style={{ width: '20px' }}></th>
                                            <th >Costo</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>Costo de produccion antes de gastos fijos</td>
                                            <th style={{ width: '20px' }}>$</th>
                                            <td>{formatMoney(costoProduccionSinGastosFijos)}</td>
                                        </tr>
                                        <tr >
                                            <td >
                                                {tipoMembrana === 'membrana' ? 'Gastos fijos a 50 piezas de produccion diarias' : 'Gastos fijos a 10 piezas de produccion diarias'}
                                            </td>
                                            <th style={{ width: '20px' }}>$</th>
                                            <td >{formatMoney(gastosFijosDiarios10pza)}</td>
                                        </tr>
                                        <tr >
                                            <td >Costo total de producción considerando gastos fijos</td>
                                            <th style={{ width: '20px' }}>$</th>
                                            <td >{formatMoney(costoTotalProduccion)}</td>
                                        </tr>
                                        <tr>
                                            <td >Margen de utilidad del 40%</td>
                                            <th style={{ width: '20px' }}>$</th>
                                            <td >{formatMoney(margenDeUtilidad)}</td>
                                        </tr>
                                        <tr>
                                            <td className='text-bold'>Precio a distribuidor</td>
                                            <th className='text-bold' style={{ width: '20px' }}>$</th>
                                            <td className='text-bold' >{formatMoney(precioDistribuidor)}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </Grid>
                            <Grid item xs={12} md={6} lg={3}>
                                <p style={{ fontSize: '0.6em' }}>Utilidad de Distribuidor</p>
                                <table className="table table-striped" style={{ fontSize: '12px' }}>
                                    <thead>
                                        <tr>
                                            <th >Concepto</th>
                                            <th style={{ width: '20px' }}></th>
                                            <th >Costo</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td >Precio a distribuidor</td>
                                            <th style={{ width: '20px' }}>$</th>
                                            <td >{formatMoney(precioDistribuidor)}</td>
                                        </tr>
                                        <tr>
                                            <td>Gastos fijos de Distribuidor</td>
                                            <th style={{ width: '20px' }}>$</th>
                                            <td>{formatMoney(gatsosDistribuidor)}</td>
                                        </tr>
                                        <tr>
                                            <td >Utilidad 40%</td>
                                            <th style={{ width: '20px' }}>$</th>
                                            <td >{formatMoney(utilidadDistriuidor)}</td>
                                        </tr>
                                        <tr>
                                            <td >Precio Unitario</td>
                                            <th style={{ width: '20px' }}>$</th>
                                            <td >{formatMoney(precioDistribuidor + gatsosDistribuidor + utilidadDistriuidor)}</td>
                                        </tr>
                                        <tr>
                                            <td >IVA</td>
                                            <th style={{ width: '20px' }}>$</th>
                                            <td >{formatMoney(ivaCliente)}</td>
                                        </tr>
                                        <tr>
                                            <td className='text-bold' >Precio al público</td>
                                            <th className='text-bold' style={{ width: '20px' }}>$</th>
                                            <td className='text-bold' >{formatMoney(precioCliente)}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </Grid>
                            <Grid item xs={12} md={6} lg={3}>
                                <p style={{ fontSize: '0.6em' }}>Precio al Cliente</p>
                                <table className="table table-striped" style={{ fontSize: '12px' }}>
                                    <thead>
                                        <tr>
                                            <th >Concepto</th>
                                            <th style={{ width: '20px' }}></th>
                                            <th >Costo</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td >Precio a distribuidor</td>
                                            <th style={{ width: '20px' }}>$</th>
                                            <td >{formatMoney(precioDistribuidor)}</td>
                                        </tr>
                                        <tr>
                                            <td>Gastos fijos de Distribuidor</td>
                                            <th style={{ width: '20px' }}>$</th>
                                            <td>{formatMoney(gatsosDistribuidor)}</td>
                                        </tr>
                                        <tr>
                                            <td >Utilidad 40%</td>
                                            <th style={{ width: '20px' }}>$</th>
                                            <td >{formatMoney(utilidadDistriuidor)}</td>
                                        </tr>
                                        <tr>
                                            <td >Precio Unitario</td>
                                            <th style={{ width: '20px' }}>$</th>
                                            <td >{formatMoney(precioDistribuidor + gatsosDistribuidor + utilidadDistriuidor)}</td>
                                        </tr>
                                        <tr>
                                            <td >IVA</td>
                                            <th style={{ width: '20px' }}>$</th>
                                            <td >{formatMoney(ivaCliente)}</td>
                                        </tr>
                                        <tr>
                                            <td className='text-bold' >Precio al público</td>
                                            <th className='text-bold' style={{ width: '20px' }}>$</th>
                                            <td className='text-bold' >{formatMoney(precioCliente)}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </Grid>
                        </Grid>

                        <Divider className='my-3' textAlign="left">
                            <Chip variant='outlined' color='secondary' label='Cotización' className='text-bold' />
                        </Divider> */}

                        {/* <FormatoCotizacion cantidad={cantidad} precioUnitario={precioDistribuidor + gatsosDistribuidor + utilidadDistriuidor} iva={ivaCliente} total={precioCliente} /> */}

                    </Paper> : <></>}
            </Container>

        </Container>
    )
}

export default CotizadorMembranas;